import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { formatTime } from '../utils/timeUtils';
import { checkActionCode } from 'firebase/auth';
import { getDinoVideoUrl } from '../utils/firestoreApi';
import YoutubeIframe_L from './YoutubeIframe_L';


const GameContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0; /* 메인 페이지 홈버튼이 클릭 가능하도록 낮은 z-index 설정 */
  
`;

const GameCanvas = styled.canvas`
  border: 2px solid #333;
  background: #f7f7f7;
  max-width: 90%;
  max-height: 100%;
`;

const Header = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackButton = styled(motion.button)`
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const GameTitle = styled.h1`
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Courier New', 'VT323', 'Press Start 2P', monospace;
`;

const ScoreDisplay = styled.div`
  position: absolute;
  top: 80px;
  right: 20px;
  color: white;
  font-size: 18px;
  font-weight: bold;
  font-family: 'Arial', sans-serif;
`;

const Instructions = styled.div`
  bottom: 20px;
  color: white;
  text-align: center;
  font-size: 1rem;
  opacity: 0.8;
  font-family: 'Arial', sans-serif;

  @media (max-width: 768px) {
    font-size: 0.7rem; 
  }
`;

const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.14);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  z-index: 2; /* 게임 오버레이의 z-index */
`;

const GameOverContent = styled.div`
  width: 400px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  border: 1px solid white;
  color: white;
  min-width: 300px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    width: 300px;
    height: 150px;
    font-size: 0.7rem;
  }
`;

const GameOverTitle = styled.h2`
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Arial', sans-serif;
`;

const FinalScore = styled.div`
  color: white;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Arial', sans-serif;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const GameOverButton = styled(motion.button)`
  background: white;
  color: #ff6b6b;
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }
`;

const CountdownOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2; /* 카운트다운 오버레이의 z-index */
`;

const CountdownText = styled.div`
  font-size: 48px;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Courier New', 'VT323', 'Press Start 2P', monospace;
  
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }
`;

const GameTimer = styled.div`
  position: absolute;
  top: 80px;
  left: 20px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  z-index: 1000;
  font-family: 'Courier New', 'VT323', 'Press Start 2P', monospace;
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /*background-color: rgba(0, 0, 0, 0.8);*/
  z-index: ${props => props.isMini ? '-999' : '1'};
  opacity: ${props => props.isMini ? '0' : '1'};
`;

const VideoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: static;
  width: 90%;
  max-width: 800px;
  aspect-ratio: 16/9;
  z-index: auto;
  border-radius: 15px;
  align-self: center;
  pointer-events: ${({ isMini }) => (isMini ? 'none' : 'auto')};
`;

const VideoInstructions = styled.div`
  color: white;
  font-size: 16px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const CharacterSelector = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    gap: 10px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
`;

const CharacterButton = styled.button`
  width: 66px;
  height: 66px;
  border: 3px solid transparent;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  
  &:hover {
    transform: scale(1.1);
  }
  
  &.selected {
    border-color: var(--primary-color);
    box-shadow: 0 0 15px rgba(255, 107, 107, 0.6);
  }
  
  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;

const CharacterImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const DinoGame = ({ onBackToHome, onComplete, audioController }) => {
  const canvasRef = useRef(null);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [gameTime, setGameTime] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  
  // YouTube 영상 관련 상태
  const [videoUrl, setVideoUrl] = useState('');
  const [showVideo, setShowVideo] = useState(true);
  const [videoReady, setVideoReady] = useState(false);
  const [videoStarted, setVideoStarted] = useState(false);
  const [isVideoMini, setIsVideoMini] = useState(false);
  const [focusLostDuringVideo, setFocusLostDuringVideo] = useState(false);
  const videoRef = useRef(null);
  
  // 주인공 캐릭터 선택 상태
  const [selectedCharacter, setSelectedCharacter] = useState(0); // 기본값은 첫 번째 캐릭터
  
  // 주인공 캐릭터 이미지 배열 (임시로 빈 이미지 사용)
  const characterImages = [
    '/Dino/JIEUN.webp?v=1', // 첫 번째 캐릭터
    '/Dino/DOEUN.webp?v=1', // 두 번째 캐릭터
    '/Dino/JIANA.webp?v=1', // 세 번째 캐릭터
    '/Dino/SUNHYE.webp?v=1', // 네 번째 캐릭터
    '/Dino/YEONJUNG.webp?v=1'  // 다섯 번째 캐릭터
  ];
  
  // 캐릭터별 달리기/점프 이미지 매핑
  const characterGameImages = {
    0: { // 1번 캐릭터 (지은)
      name: '지은',
      run: '/Dino/YPS_jieun_run.webp?v=1',
      jump: '/Dino/YPS_jieun_jump.webp?v=1'
    },
    1: { // 2번 캐릭터 (도은)
      name: '도은',
      run: '/Dino/YPS_doeun_run.webp?v=1',
      jump: '/Dino/YPS_doeun_jump.webp?v=1'
    },
    2: { // 3번 캐릭터 (지아나)
      name: '지아나',
      run: '/Dino/YPS_jiana_run.webp?v=1',
      jump: '/Dino/YPS_jiana_jump.webp?v=1'
    },
    3: { // 4번 캐릭터 (선혜)
      name: '선혜',
      run: '/Dino/YPS_sunhye_run.webp?v=1',
      jump: '/Dino/YPS_sunhye_jump.webp?v=1'
    },
    4: { // 5번 캐릭터 (위연정)
      name: '연정',
      run: '/Dino/YPS_yeonjung_run.webp?v=1',
      jump: '/Dino/YPS_yeonjung_jump.webp?v=1'
    }
  };
  
  // 오디오 관련 ref들
  const jumpSound = useRef(null);
  const gameOverSound = useRef(null);
  const audioContext = useRef(null);
  const audioBuffer = useRef(null);
  const gameOverBuffer = useRef(null);
  const audioInitialized = useRef(false);

  // 오디오 파일 경로 상수
  const JUMP_SOUND = '/jump.mp3';
  const GAME_OVER_SOUND = '/gameover.mp3';

  // 파이어스토어에서 영상 URL 가져오기
  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const url = await getDinoVideoUrl();
        setVideoUrl(url);
      } catch (error) {
        //console.error('영상 URL 가져오기 실패:', error);
        // 에러 발생 시 기본 영상 URL
        setVideoUrl('https://www.youtube.com/watch?v=v3kEHHkRvks');
      }
    };

    fetchVideoUrl();
  }, []);
  
  // YouTube 영상 이벤트 핸들러들
  const handleVideoReady = () => {
    setVideoReady(true);
  };

  const handleVideoStart = () => {
    setVideoStarted(true);
  };
  
  // 캐릭터 선택 핸들러
  const handleCharacterSelect = (index) => {
    setSelectedCharacter(index);
  };

  // 게임 상태 초기화 함수 (카운트다운 대신 사용)
  const initializeGameState = () => {
    setGameTime(0);
    setScore(0);
    setGameOver(false);
    
    // 게임 상태 초기화
    gameState.current = {
      ...gameState.current,
      score: 0,
      gameOver: false,
      gameOverTime: 0,
      onCompleteCalled: false,
      dino: {
        ...gameState.current.dino,
        y: 200,
        velocityY: 0,
        isJumping: false,
        jumpCount: 0,
        rotation: 0,
        isFalling: false,
        hasLanded: false,
        isPaused: false
      },
      obstacles: [],
      gameSpeed: 4,
      lastCactusTime: Date.now(),
      lastBirdTime: Date.now(),
      lastPterodactylTime: Date.now()
    };
  };

  const handleVideoMini = () => {
    // 카운트다운이 끝나면 게임 시작
    setIsVideoMini(true);
    
    // 영상이 작아진 후에는 더 이상 조작할 수 없도록 함
    // (일시정지하지 않고 계속 재생되도록)
    
    if (!gameStarted && imagesLoaded) {
      // 게임 시작 전 이미지 상태 최종 확인
      
      initializeGameState();
      setGameStarted(true);
      startGame();
      
      // 영상 재생 후 포커스 out 되면 일시정지
      if(document.hidden || !document.hasFocus()) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
      
      // 게임 시작 시 포커스 주기
      setTimeout(() => {
        document.body.focus();
        window.focus();
      }, 100);
    }
  };

  // isPaused 상태 변화 감지
  useEffect(() => {
  gameState.current.dino.isPaused = isPaused;
  //console.log('isPaused 상태 변화:', isPaused);
  
  // 일시정지 상태가 변경될 때 lastFrameTime 업데이트
  if (!isPaused) {
    lastFrameTime.current = Date.now();
  }
}, [isPaused]);

  // 브라우저 포커스 이벤트 리스너 추가
  useEffect(() => {
    const handleVisibilityChange = () => {
        //console.log('🔄 visibilitychange 이벤트 발생:', {
        //  hidden: document.hidden,
        //  visibilityState: document.visibilityState,
        //  timestamp: new Date().toISOString()
        //});
      if (document.hidden) {
        // 영상 재생 중에는 일시정지하지 않음, 게임 오버 후에도 일시정지하지 않음
        if (!showVideo && !gameOver && !gameState.current.gameOver) {
          setIsPaused(true);
          gameState.current.dino.isPaused = true;
          pauseMusic(); // YouTube 영상 일시정지
        }
      } else {
        // 포커스가 돌아와도 자동으로 게임을 재개하지 않음
        // 점프 버튼을 눌러야만 게임이 재개됨
        // setIsPaused(false);
        // gameState.current.dino.isPaused = false;
        // 음악 재생은 점프 버튼에서 처리 (다른 이벤트 핸들러와 일관성 유지)
      }
    };

    const handleWindowBlur = () => {
      // 영상이 작아진 후에만 일시정지, 게임 오버 후에는 일시정지하지 않음
      if (gameStarted && isVideoMini && !gameOver && !gameState.current.gameOver) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
    };

    const handleWindowFocus = () => {
      // 게임이 진행 중일 때만 상태 변경
      if (!gameOver && !gameState.current.gameOver) {
        // 단순히 상태만 변경 (음악 재생은 점프 버튼에서 처리)
        // setIsPaused(false);
        // gameState.current.dino.isPaused = false;
      }
    };

         const handlePageHide = (event) => {
      // 영상이 작아진 후에만 일시정지, 게임 오버 후에는 일시정지하지 않음
      if (gameStarted && isVideoMini && !gameOver && !gameState.current.gameOver) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
    };


         const handleBeforeUnload = () => {
      // 영상 재생 중이거나 게임 진행 중이면 일시정지, 게임 오버 후에는 일시정지하지 않음
      if (((showVideo && !isVideoMini) || (gameStarted && isVideoMini)) && !gameOver && !gameState.current.gameOver) {
        if (showVideo && !isVideoMini) {
          // 영상이 재생 중이면 미니사이즈로 전환 후 일시정지
          setIsVideoMini(true);
          setTimeout(() => {
            pauseMusic(); // YouTube 영상 일시정지
          }, 100);
        } else {
          // 이미 미니사이즈면 바로 일시정지
          setIsPaused(true);
          gameState.current.dino.isPaused = true;
          pauseMusic(); // YouTube 영상 일시정지
        }
      }
    };


    const handleSuspend = () => {
      // 영상이 작아진 후에만 일시정지
      if (gameStarted && isVideoMini) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
    };

          // 사파리에서 더 확실한 감지를 위한 추가 이벤트들
      const handleFocusOut = () => {
      // 게임이 진행 중일 때만 일시정지
      if (gameStarted) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
    };


          // 사파리에서 freeze/unfreeze 이벤트 (iOS 13+)
      const handleFreeze = () => {
      // 게임이 진행 중일 때만 일시정지
      if (gameStarted) {
        setIsPaused(true);
        gameState.current.dino.isPaused = true;
        pauseMusic(); // YouTube 영상 일시정지
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleWindowBlur);
    window.addEventListener('focus', handleWindowFocus);
    document.addEventListener('blur', handleWindowBlur);
    document.addEventListener('focus', handleWindowFocus);
 
    //window.addEventListener('focusout', handleFocusOut);
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('beforeunload', handleBeforeUnload);
    
    // 사파리 특화 이벤트들
    window.addEventListener('suspend', handleSuspend);
    window.addEventListener('freeze', handleFreeze);
    // 클린업
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleWindowBlur);
      window.removeEventListener('focus', handleWindowFocus);

      //window.removeEventListener('focusout', handleFocusOut);
      window.removeEventListener('pagehide', handlePageHide);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('suspend', handleSuspend);
      window.removeEventListener('freeze', handleFreeze);
      
    };
  }, [gameStarted, isVideoMini, gameOver, showVideo]); // 상태 변화 감지
  
  // 일시정지 후 재개를 위한 함수
  const resumeGame = () => {
    if (!gameState.current.dino.isPaused) {
      // 기존 카운트다운이 있다면 정리
      if (countdownRef.current) {
        clearInterval(countdownRef.current);
      }
      // 게임 재개 시 음악도 재개
      resumeMusic();
    }
  };

  // 장애물 팩토리 함수들
  const createObstacle = (type, x, y, width, height) => ({
    x, y, width, height, type
  });

  const createCactus = (x, y, size = 'small') => {
    if (size === 'small') {
      return createObstacle('cactus_small', x, y, 20, 40);
    } else {
      return createObstacle('cactus_large', x, y-15, 25, 55);
    }
  };

  const createBird = (x, y) => {
    return createObstacle('bird', x, y, 30, 20);
  };

  const createPterodactyl = (x, y) => {
    return createObstacle('pterodactyl', x, y, 35, 25);
  };

  const createCactusPair = (x) => {
    const firstSize = Math.random() < 0.5 ? 'small' : 'large';
    const secondSize = Math.random() < 0.5 ? 'small' : 'large';
    
    const firstCactus = createCactus(x, gameState.current.groundY, firstSize);
    const secondCactus = createCactus(x + 30, gameState.current.groundY, secondSize);
    
    return [firstCactus, secondCactus];
  };

  const createSingleCactus = (x) => {
    const size = Math.random() < 0.6 ? 'small' : 'large';
    return createCactus(x, gameState.current.groundY, size);
  };
  
  // 게임 상태
  const gameState = useRef({
    dino: {
      x: 50,
      y: 200,
      width: 40,
      height: 40,
      velocityY: 0,
      isJumping: false,
      isPaused: false,
      jumpCount: 0, // 점프 횟수 추가
      maxJumps: 2,   // 최대 점프 횟수
      rotation: 0,    // 회전 각도 (도)
      isFalling: false, // 떨어지는 상태
      hasLanded: false  // 바닥에 착지했는지
    },
    obstacles: [],
    clouds: [
      { x: 100, y: 50, width: 60, height: 20 },
      { x: 300, y: 80, width: 80, height: 25 },
      { x: 600, y: 60, width: 70, height: 20 }
    ],
    stones: [
      { x: 200, y: 240, width: 15, height: 10 },
      { x: 400, y: 245, width: 12, height: 8 },
      { x: 700, y: 242, width: 18, height: 12 }
    ],
    gameSpeed: 4, // 속도를 더 낮춤
    gravity: 0.45, // 중력 낮춤
    jumpPower: -10, // 점프력 조정
    groundY: 200,
    // 각 장애물 타입별 독립적인 타이머 (현재 시간으로 초기화)
    lastCactusTime: Date.now(),
    lastBirdTime: Date.now(),
    lastPterodactylTime: Date.now(),
    score: 0, // 점수를 게임 상태에 추가
    gameOver: false, // 게임 오버 상태 추가
    gameOverTime: 0,  // 게임 오버 시작 시간
    onCompleteCalled: false,  // onComplete 호출 여부 플래그
    gameTime: 0 // 게임 시간
  });

  const animationRef = useRef(null);
  const countdownRef = useRef(null);
  const timerRef = useRef(null);

  // 게임 초기화
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Canvas 크기 설정
    canvas.width = 800;
    canvas.height = 300;
    
    // 사용자 제스처 순간에 오디오 버퍼 재생 테스트
    // 첫 터치/키 입력 시 무음 버퍼를 재생해서 iOS에서 오디오 정책을 해제
    const handleUserInteraction = async () => {
      if (!audioInitialized.current) {
        try {
          // Web Audio API 초기화
          audioContext.current = new (window.AudioContext || window.webkitAudioContext)();
          
          // AudioContext resume 보장
          if (audioContext.current.state === "suspended") {
            await audioContext.current.resume();
          }

          // 무음 버퍼 재생 (iOS Safari 해제용)
          const buffer = audioContext.current.createBuffer(1, 1, 22050);
          const source = audioContext.current.createBufferSource();
          source.buffer = buffer;
          source.connect(audioContext.current.destination);
          source.start(0);

          // 효과음 로드
          const jumpResponse = await fetch(JUMP_SOUND);
          const jumpArrayBuffer = await jumpResponse.arrayBuffer();
          audioBuffer.current = await audioContext.current.decodeAudioData(jumpArrayBuffer);

          const gameOverResponse = await fetch(GAME_OVER_SOUND);
          const gameOverArrayBuffer = await gameOverResponse.arrayBuffer();
          gameOverBuffer.current = await audioContext.current.decodeAudioData(gameOverArrayBuffer);

          audioInitialized.current = true;
          //console.log("🔊 오디오 초기화 완료 (iOS 대응)");
        } catch (err) {
          //console.warn("오디오 초기화 실패:", err);
          // 폴백 Audio 객체
          jumpSound.current = new Audio(JUMP_SOUND);
          gameOverSound.current = new Audio(GAME_OVER_SOUND);
          jumpSound.current.play().catch(()=>{}); // iOS 정책 해제
          gameOverSound.current.play().catch(()=>{}); // iOS 정책 해제
          audioInitialized.current = true;
        }

        // 이벤트 리스너 제거
        document.removeEventListener('touchstart', handleUserInteraction);
        document.removeEventListener('touchend', handleUserInteraction);
        document.removeEventListener('mousedown', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
        document.removeEventListener('gesturestart', handleUserInteraction);
      }
    };
    
    document.addEventListener('touchstart', handleUserInteraction);
    document.addEventListener('touchend', handleUserInteraction);
    document.addEventListener('mousedown', handleUserInteraction);
    document.addEventListener('keydown', handleUserInteraction);
    document.addEventListener('gesturestart', handleUserInteraction);
    
    return () => {
        if (countdownRef.current) {
          clearInterval(countdownRef.current);
        }
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
      // 오디오 컨텍스트 정리
      if (audioContext.current) {
        try {
          audioContext.current.close();
        } catch (e) {
          // 이미 닫힌 상태면 무시
        }
      }
    };
  }, []);

  // 게임 시작 함수
  const startGame = async () => {
    // 기존 타이머가 있다면 정리
    if (timerRef.current) {
      clearInterval(timerRef.current); 
      timerRef.current = null;
    }

    // 게임 타이머 시작
    const timerInterval = setInterval(() => {
      // 일시정지 상태가 아닐 때만 시간 증가
      if (!gameState.current.dino.isPaused) {
        setGameTime(prev => {
          const newTime = prev + 1;
          gameState.current.gameTime = newTime; // gameState도 함께 업데이트
          return newTime;
        });
      }
    }, 1000);
    
    timerRef.current = timerInterval;
    
    // 게임 루프 시작
    const canvas = canvasRef.current;
    if (!canvas) {
      //console.warn('Canvas is not ready yet');
      return;
    }
    const ctx = canvas.getContext('2d');
    
    // 게임 시작 시 lastFrameTime 초기화
    lastFrameTime.current = Date.now();
    
    const gameLoop = () => {
      // 게임이 일시정지되었으면 렌더링하지 않음
      if (gameState.current.dino.isPaused) {
        animationRef.current = requestAnimationFrame(gameLoop);
        return;
      }

      updateGame();
      drawGame(ctx);
      animationRef.current = requestAnimationFrame(gameLoop);
    };
    
    gameLoop();
  };

  // 키보드 이벤트
  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (e.code === 'Space' || e.code === 'ArrowUp') {
        e.preventDefault();
        // 게임 오버 상태에서는 점프하지 않음
        if (!gameOver && !gameState.current.gameOver) {
          await jump();
        }
      }
    };


    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [gameOver]);

  // 터치 이벤트 (모바일용)
  useEffect(() => {
    if (gameStarted && !gameOver) {
      const handleTouch = async (e) => {
        // 배너 영역 제외 (데스크톱: 100px, 모바일: 80px)
        const bannerHeight = window.innerWidth <= 768 ? 80 : 100;
        
        // 게임 오버 상태에서는 점프하지 않음
        if (!gameOver && !gameState.current.gameOver) {
          if (e.touches[0].clientY >= bannerHeight) {
            // 배너 영역 아래에서만 점프
            e.preventDefault();
            await jump();
          }
          // 배너 영역에서는 preventDefault 호출하지 않음 (터치 정상 작동)
        }
      };

      // 화면 전체에 터치 이벤트 추가
      document.addEventListener('touchstart', handleTouch, { passive: false });
      
      return () => {
        document.removeEventListener('touchstart', handleTouch);
      };
    }
  }, [gameStarted, gameOver]);

  // 점프 함수
  // 배경음악 재생 함수
  const playMusic = () => {
    // console.log('playMusic 호출됨 - audioController 상태:', {
    //   exists: !!audioController,
    //   isInitialized: audioController?.isInitialized,
    //   isDestroyed: audioController?.isDestroyed,
    //   isPlaying: audioController?.isPlaying
    // });
    
    // 게임 오버 상태에서는 음악을 재생하지 않음
    if (gameOver || gameState.current.gameOver) {
      return;
    }
    
    // audioController만 사용
    if (audioController && !audioController.isDestroyed) {
      try {
        audioController.play();
      } catch (error) {
        //console.warn('음악 재생 실패:', error);
      }
    }
  };

  // 배경음악 정지 함수
  const stopMusic = () => {
    // audioController만 사용
    if (audioController && !audioController.isDestroyed) {
      try {
        audioController.stop();
      } catch (error) {
        //console.warn('음악 정지 실패:', error);
      }
    }
  };

  const pauseMusic = () => {
    // YouTube 영상 일시정지
    if (videoRef.current && videoRef.current.pauseVideo) {
      try {
        videoRef.current.pauseVideo();
      } catch (error) {
        //console.warn('영상 일시정지 실패:', error);
      }
    }
  };

  const resumeMusic = () => {
    // 게임 오버 상태가 아닐 때만 영상 재생
    if (gameOver || gameState.current.gameOver) {
      return;
    }
    
    // YouTube 영상 재생 (점프할 때만 호출됨)
    if (videoRef.current && videoRef.current.playVideo) {
      try {
        videoRef.current.playVideo();
      } catch (error) {
        //console.warn('영상 재생 실패:', error);
      }
    }
  };

  const jump = () => {
    // 게임 오버 상태에서는 점프하지 않음
    if (gameOver || gameState.current.gameOver) {
      return;
    }
    
    if (gameState.current.dino.isPaused) {
      setIsPaused(false);
      gameState.current.dino.isPaused = false;
      // 일시정지 해제 시 게임 재개
      resumeGame();
    }
    const dino = gameState.current.dino;
    if (dino.jumpCount < dino.maxJumps) {
      dino.isJumping = true;
      dino.jumpCount++;
      
      // 2단 점프일 때는 점프 능력의 80%만 적용
      const jumpPower = dino.jumpCount === 1 ? gameState.current.jumpPower : gameState.current.jumpPower * 0.8;
      dino.velocityY = jumpPower;
      
      // 점프 효과음 재생 (iOS 대응)
      if (audioInitialized.current) {
        try {
          if (audioContext.current && audioBuffer.current) {
            // Web Audio API 사용 (iOS 대응)
            // AudioContext resume 보장
            if (audioContext.current.state === "suspended") {
              audioContext.current.resume();
            }
            
            const source = audioContext.current.createBufferSource();
            source.buffer = audioBuffer.current;
            source.connect(audioContext.current.destination);
            source.start(0);
          } else if (jumpSound.current) {
            // 폴백: 기본 Audio 객체 사용 (iOS 대응)
            jumpSound.current.currentTime = 0.0;
            jumpSound.current.play().catch(e => {});//console.log('점프 효과음 재생 실패:', e));
          }
        } catch (error) {
          //console.log('점프 효과음 재생 실패:', error);
        }
      }
    }
  };

  // 게임오버 효과음 재생 함수
  const playGameOverSound = () => {
    if (audioInitialized.current) {
      try {
        if (audioContext.current && gameOverBuffer.current) {
          // Web Audio API 사용 (iOS 대응)
          // AudioContext resume 보장
          if (audioContext.current.state === "suspended") {
            audioContext.current.resume();
          }
          
          const source = audioContext.current.createBufferSource();
          source.buffer = gameOverBuffer.current;
          source.connect(audioContext.current.destination);
          source.start(0);
        } else if (gameOverSound.current) {
          // 폴백: 기본 Audio 객체 사용 (iOS 대응)
          gameOverSound.current.currentTime = 0.0;
          gameOverSound.current.play().catch(e => {});//console.log('게임오버 효과음 재생 실패:', e));
        }
      } catch (error) {
        //console.log('게임오버 효과음 재생 실패:', error);
      }
    }
  };

  // updateGame 함수 내에서
  let lastFrameTime = useRef(Date.now());

  const updateGame = () => {
    const now = Date.now();
    
    // 일시정지 상태면 업데이트 중단
    if (gameState.current.dino.isPaused) {
      return;
    }
    
    const deltaTime = (now - lastFrameTime.current) / (1000 / 60); // 60fps 기준 프레임 환산
    lastFrameTime.current = now;

    
    const state = gameState.current;
    
    // 게임 오버 후 떨어지는 애니메이션 처리
    if (state.gameOver && state.dino.isFalling) {
      // 공룡 떨어지는 애니메이션
      state.dino.y += state.dino.velocityY * deltaTime;
      state.dino.velocityY += state.gravity * deltaTime;
      
      // 회전 애니메이션 (180도까지)
      if (state.dino.rotation < 180) {
        state.dino.rotation += 3 * deltaTime; // 회전 속도
        if (state.dino.rotation > 180) {
          state.dino.rotation = 180;
        }
      }
      
      // 바닥에 도달했는지 확인
      if (state.dino.y >= state.groundY + 150) { // 바닥 높이
        state.dino.y = state.groundY + 150;
        state.dino.velocityY = 0;
        state.dino.isFalling = false;
        state.dino.hasLanded = true;
        
        // 바닥에 착지한 시점에 gameOverTime 설정
        if (!state.gameOverTime) {
          state.gameOverTime = now;
        }
      }
      return; // 게임 오버 후에는 다른 업데이트 중단
    }
    
    // 게임 오버 후 바닥에 착지한 상태에서 1초 대기
    if (state.gameOver && state.dino.hasLanded) {
      if (now - state.gameOverTime > 1000 && !state.onCompleteCalled) { // 1초 대기
        state.onCompleteCalled = true; // 플래그 설정
        if (onComplete) {
          onComplete({
            timeSpent: formatTime(state.gameTime * 1000),
            timeSpentMs: state.gameTime * 1000, // 숫자 필드 추가
            score: Math.floor(state.score),
            gameType: 'dino'
          });
        }
      }
      return; // 게임 오버 후에는 다른 업데이트 중단
    }
    
    if (gameOver || state.gameOver ) return;

    // 공룡 중력/점프 적용 (게임 오버가 아닐 때만)
    if (!state.gameOver && !isPaused) {
      state.dino.y += state.dino.velocityY * deltaTime;
      state.dino.velocityY += state.gravity * deltaTime;
      if (state.dino.y >= state.groundY) {
        state.dino.y = state.groundY;
        state.dino.velocityY = 0;
        state.dino.isJumping = false;
        state.dino.jumpCount = 0;
      }
    }

    // 장애물 이동 (게임 오버가 아닐 때만)
    if (!state.gameOver ) {
      for (let i = state.obstacles.length - 1; i >= 0; i--) {
        const obstacle = state.obstacles[i];
        let speedMultiplier = 1; // 기본 속도
        
        // 새는 1.2배, 익룡은 1.5배 빠르게
        if (obstacle.type === 'bird') {
          speedMultiplier = 1.2;
        } else if (obstacle.type === 'pterodactyl') {
          speedMultiplier = 1.5;
        }
        
        obstacle.x -= state.gameSpeed * deltaTime * speedMultiplier;
        if (obstacle.x + obstacle.width < 0) {
          state.obstacles.splice(i, 1);
        }
      }
    }

    // 돌 이동 (게임 오버가 아닐 때만)
    if (!state.gameOver ) {
      state.stones.forEach(stone => {
        stone.x -= state.gameSpeed * deltaTime;
        if (stone.x + stone.width < 0) {
          stone.x = 800;
        }
      });

      // 구름 이동 (배경)
      state.clouds.forEach(cloud => {
        cloud.x -= state.gameSpeed * 0.5 * deltaTime;
        if (cloud.x + cloud.width < 0) {
          cloud.x = 800;
        }
      });
    }

    // 점수 증가 (게임 오버가 아니고 일시정지가 아닐 때만)
    if (!state.gameOver && !state.dino.isPaused) {
      state.score += 1 * deltaTime / 2;
      setScore(Math.floor(state.score));

      // 게임 속도 증가 (100점마다)
      if (state.score > 0 && Math.floor(state.score) % 100 === 0) {
        state.gameSpeed += 0.1;
      }
    }

    // 장애물 생성 (게임 오버가 아닐 때만)
    if (!state.gameOver ) {
      const currentTime = now;
      let deductTime = 0;
      deductTime = Math.floor(state.score) * 1;

      // 선인장 생성: 2초(2100ms)마다 20% 확률
      if (currentTime - state.lastCactusTime > (2580 - deductTime) && Math.random() < 0.2) {
        if (Math.random() < 0.2) {
          const cactusPair = createCactusPair(800);
          state.obstacles.push(...cactusPair);
        } else {
          const size = Math.random() < 0.5 ? 'small' : 'large';
          const singleCactus = createCactus(800, state.groundY, size);
          state.obstacles.push(singleCactus);
        }
        state.lastCactusTime = currentTime;
      }
      // 새 생성: 5.7초(5700ms)마다 10% 확률
      if (currentTime - state.lastBirdTime > (3810 - deductTime) && Math.random() < 0.1) {
        const bird = createBird(800, state.groundY - 60);
        state.obstacles.push(bird);
        state.lastBirdTime = currentTime;
      }
      // 익룡 생성: 7.5초(7500ms)마다 10% 확률
      if (currentTime - state.lastPterodactylTime > (5960 - deductTime) && Math.random() < 0.1) {
        const pterodactyl = createPterodactyl(800, state.groundY - 160);
        state.obstacles.push(pterodactyl);
        state.lastPterodactylTime = currentTime;
      }
    }

    // 충돌 판정 및 게임 오버 등 기존 로직 유지
    for (let i = state.obstacles.length - 1; i >= 0; i--) {
      const obstacle = state.obstacles[i];
      
      // 화면 밖으로 나간 장애물 제거
      if (obstacle.x + obstacle.width < 0) {
        state.obstacles.splice(i, 1);
        state.score += 5; // 게임 상태의 점수 업데이트
        setScore(state.score); // React 상태 동기화
        continue; // 다음 장애물로
      }
      
      // 충돌 체크 (게임 오버가 아닐 때만)
      if (!gameOver && !state.gameOver) {
        if (
          state.dino.x < obstacle.x + obstacle.width &&
          state.dino.x + state.dino.width > obstacle.x &&
          state.dino.y < obstacle.y + obstacle.height &&
          state.dino.y + state.dino.height > obstacle.y
        ) {
          handleGameOver();
          return; // 충돌 감지 시 즉시 함수 종료
        }
      }
    }
  };

  // useEffect에서 lastFrameTime.current = Date.now()로 초기화 필요
  useEffect(() => {
    lastFrameTime.current = Date.now();
  }, [gameStarted]);

  // 장애물 그리기 함수들
  const drawCactus = (ctx, obstacle) => {
    ctx.fillStyle = '#228B22';
    ctx.fillRect(obstacle.x, obstacle.y, obstacle.width, obstacle.height);
    
    // 가시 그리기
    ctx.fillStyle = '#006400';
    if (obstacle.type === 'cactus_small') {
      // 작은 선인장 가시
      ctx.fillRect(obstacle.x + 5, obstacle.y + 10, 2, 5);
      ctx.fillRect(obstacle.x + 15, obstacle.y + 15, 2, 5);
    } else {
      // 큰 선인장 가시 (더 많고 다양하게)
      ctx.fillRect(obstacle.x + 3, obstacle.y + 8, 2, 6);
      ctx.fillRect(obstacle.x + 8, obstacle.y + 12, 2, 8);
      ctx.fillRect(obstacle.x + 15, obstacle.y + 10, 2, 7);
      ctx.fillRect(obstacle.x + 20, obstacle.y + 15, 2, 5);
      ctx.fillRect(obstacle.x + 12, obstacle.y + 25, 2, 6);
      ctx.fillRect(obstacle.x + 18, obstacle.y + 30, 2, 8);
    }
  };

  const drawBird = (ctx, obstacle) => {
    // 새 몸체
    ctx.fillStyle = '#8B4513';
    ctx.fillRect(obstacle.x, obstacle.y, obstacle.width, obstacle.height);
    // 새 부리
    ctx.fillStyle = '#FFD700';
    ctx.fillRect(obstacle.x + obstacle.width, obstacle.y + 8, 5, 4);
  };

  const drawPterodactyl = (ctx, obstacle) => {
    // 익룡 몸체
    ctx.fillStyle = '#4A4A4A';
    ctx.fillRect(obstacle.x, obstacle.y, obstacle.width, obstacle.height);
    // 익룡 날개
    ctx.fillStyle = '#696969';
    ctx.fillRect(obstacle.x - 10, obstacle.y + 5, 15, 3);
    ctx.fillRect(obstacle.x + obstacle.width - 5, obstacle.y + 5, 15, 3);
    // 익룡 부리
    ctx.fillStyle = '#FFD700';
    ctx.fillRect(obstacle.x + obstacle.width, obstacle.y + 10, 8, 5);
  };

  // 선택된 캐릭터의 게임 이미지들
  const [currentRunImg, setCurrentRunImg] = useState(null);
  const [currentJumpImg, setCurrentJumpImg] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // 선택된 캐릭터가 변경될 때마다 해당 캐릭터의 이미지 로드
  useEffect(() => {
    const loadCharacterImages = async () => {
      const selectedChar = characterGameImages[selectedCharacter];
      if (!selectedChar) return;

      let loadedCount = 0;
      const totalImages = 2;
      
      const checkAllLoaded = () => {
        loadedCount++;
        if (loadedCount >= totalImages) {
          setImagesLoaded(true);
        }
      };
      
      // 달리기 이미지 로드
      const runImg = new window.Image();
      runImg.src = selectedChar.run;
      runImg.onload = () => { 
        setCurrentRunImg(runImg); 
        checkAllLoaded();
      };
      runImg.onerror = () => { 
        //console.log(`${selectedChar.run} 로드 실패`);
        setCurrentRunImg(null);
        checkAllLoaded();
      };
      
      // 점프 이미지 로드
      const jumpImg = new window.Image();
      jumpImg.src = selectedChar.jump;
      jumpImg.onload = () => { 
        setCurrentJumpImg(jumpImg); 
        checkAllLoaded();
      };
      jumpImg.onerror = () => { 
        //console.log(`${selectedChar.jump} 로드 실패`);
        setCurrentJumpImg(null);
        checkAllLoaded();
      };
    };

    loadCharacterImages();
  }, [selectedCharacter]); // selectedCharacter가 변경될 때마다 실행
  
  // 컴포넌트 마운트 시 기본 캐릭터(0번) 이미지 로드
  useEffect(() => {
    if (characterImages.length > 0) {
      const loadInitialCharacter = async () => {
        const selectedChar = characterGameImages[0]; // 기본값은 첫 번째 캐릭터
        if (!selectedChar) return;

        let loadedCount = 0;
        const totalImages = 2;
        
        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount >= totalImages) {
            setImagesLoaded(true);
          }
        };
        
        // 달리기 이미지 로드
        const runImg = new window.Image();
        runImg.src = selectedChar.run;
        runImg.onload = () => { 
          setCurrentRunImg(runImg); 
          checkAllLoaded();
        };
        runImg.onerror = () => { 
          //console.log(`${selectedChar.run} 로드 실패`);
          setCurrentRunImg(null);
          checkAllLoaded();
        };
        
        // 점프 이미지 로드
        const jumpImg = new window.Image();
        jumpImg.src = selectedChar.jump;
        jumpImg.onload = () => { 
          setCurrentJumpImg(jumpImg); 
          checkAllLoaded();
        };
        jumpImg.onerror = () => { 
          //console.log(`${selectedChar.jump} 로드 실패`);
          setCurrentJumpImg(null);
          checkAllLoaded();
        };
      };

      loadInitialCharacter();
    }
  }, []); // 컴포넌트 마운트 시 한 번만 실행

  // 달리기 프레임 애니메이션은 더 이상 사용하지 않음 (캐릭터별 이미지로 대체)

  // 사람 그리기 함수 (공룡 대체)
  const drawDino = (ctx, dino, isGameOver) => {
    ctx.save();
    ctx.translate(dino.x + dino.width / 2, dino.y + dino.height / 2);
    ctx.rotate((dino.rotation * Math.PI) / 180);
    ctx.translate(-dino.width / 2, -dino.height / 2);
    
    // 선택된 캐릭터에 따른 이미지 선택
    let img = null;
    if (isGameOver) {
      // 게임 오버 시에는 달리기 이미지 사용
      img = currentRunImg;
    } else if (dino.isJumping || dino.isFalling) {
      // 점프 중일 때는 점프 이미지 사용
      img = currentJumpImg;
    } else {
      // 달리기 중일 때는 달리기 이미지 사용
      img = currentRunImg;
    }
    
    if (img) {
      ctx.drawImage(img, -30, -30, dino.width*2.0, dino.height*2.0);

      // 이미지 위에 텍스트 그리기
      ctx.fillStyle = '#f76319';
      ctx.font = 'bold 18px Arial';
      ctx.textAlign = 'center';
      // 선택된 캐릭터의 이름 표시
      const selectedChar = characterGameImages[selectedCharacter];
      const characterName = selectedChar ? selectedChar.name : '선혜';
      ctx.fillText(characterName, 10, -30); // 이미지 중심 기준으로 위쪽에 위치

    } else {
      // 이미지가 로드되지 않았을 때는 기본 사각형으로 대체
      ctx.fillStyle = isGameOver ? '#FF0000' : '#333';
      ctx.fillRect(0, 0, dino.width, dino.height);
    }
    
    ctx.restore();
  };

  // 영파씨 로고 이미지 로드
  const logoImage = useRef(null);

  // 로고 이미지 로드
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      logoImage.current = img;
    };
    img.src = '/logo.svg';
  }, []);

  // 배경 그리기 함수
  const drawBackground = (ctx) => {
    // 하늘 그리기
    ctx.fillStyle = '#87CEEB';
    ctx.fillRect(0, 0, 800, 300);
    
    // 영파씨 로고 그리기 (구름 대신)
    if (logoImage.current) {
      gameState.current.clouds.forEach((cloud, index) => {
        // 로고 크기 조정 (원래 구름 크기보다 작게)
        const logoWidth = cloud.width * 1.0;
        const logoHeight = cloud.height * 1.0;
        
        // 로고 그리기
        ctx.save();
        ctx.globalAlpha = 0.3; // 투명도 설정
        
        // 홀수/짝수에 따라 색상 필터 적용
        if (index % 2 === 0) {
          // 짝수 번째: 검은색 필터
          ctx.filter = 'brightness(0)';
        } else {
          // 홀수 번째: 흰색 필터
          ctx.filter = 'brightness(0) invert(1)';
        }
        
        ctx.drawImage(
          logoImage.current,
          cloud.x + (cloud.width - logoWidth) / 2,
          cloud.y + (cloud.height - logoHeight) / 2,
          logoWidth,
          logoHeight
        );
        ctx.restore();
      });
    }
    
    // 땅 그리기
    ctx.fillStyle = '#8B4513';
    ctx.fillRect(0, gameState.current.groundY + 40, 800, 60);
    
    // 돌맹이 그리기
    ctx.fillStyle = '#696969';
    gameState.current.stones.forEach(stone => {
      ctx.fillRect(stone.x, stone.y, stone.width, stone.height);
    });
  };

  // 장애물 그리기 함수
  const drawObstacles = (ctx) => {
    gameState.current.obstacles.forEach(obstacle => {
      if (obstacle.type === 'cactus_small') {
        drawCactus(ctx, obstacle);
      } else if (obstacle.type === 'cactus_large') {
        drawCactus(ctx, obstacle);
      } else if (obstacle.type === 'bird') {
        drawBird(ctx, obstacle);
      } else if (obstacle.type === 'pterodactyl') {
        drawPterodactyl(ctx, obstacle);
      }
    });
  };

  // UI 그리기 함수
  const drawUI = (ctx) => {
    // 점수 표시
    ctx.fillStyle = '#333';
    ctx.font = '20px Arial';
    ctx.fillText(`Score: ${Math.floor(gameState.current.score)}`, 650, 30);
    ctx.fillText(`Time: ${gameState.current.gameTime}`, 650, 60);
  };

  // 게임 그리기
  const drawGame = (ctx) => {
    // 배경 지우기
    ctx.clearRect(0, 0, 800, 300);
    
    // 배경 그리기
    drawBackground(ctx);
    
    // 공룡 그리기
    drawDino(ctx, gameState.current.dino, gameOver);
    
    // 장애물 그리기
    drawObstacles(ctx);
    
    // UI 그리기
    drawUI(ctx);
  };

      // 게임 오버 처리
    const handleGameOver = () => {
      // 이미 게임 오버 상태면 중복 처리 방지
      if (gameState.current.gameOver) {
        return;
      }
      //console.log('Game Over! Starting fall animation...');
      gameState.current.gameOver = true;

      // 게임 타이머 정리
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      
      // 게임 오버 시 영상 일시정지
      if (videoRef.current && videoRef.current.pauseVideo) {
        try {
          videoRef.current.pauseVideo();
        } catch (error) {
          //console.warn('게임 오버 시 영상 일시정지 실패:', error);
        }
      }
            
      // 게임오버 효과음 재생
      playGameOverSound();

      // 공룡을 떨어지는 상태로 설정
      gameState.current.dino.isFalling = true;
      gameState.current.dino.velocityY = -8; // 위로 살짝 올라간 후 떨어짐
      
      // 기존 setTimeout 제거 - 이제 updateGame에서 처리
    };


  return (
    <GameContainer>
      {/* <Header>
        <BackButton
          onClick={handleBackClick}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          ← 뒤로가기
        </BackButton>
        <GameTitle>🛹 파씨런</GameTitle>
        <div style={{ width: '100px' }}></div>
      </Header> */}

      {/* 점수 표시 (화면 상단) */}
      {/* <ScoreDisplay>
        Score: {Math.floor(score)}
      </ScoreDisplay>

      {gameStarted && !gameOver && (
        <GameTimer>Time: {gameTime}s</GameTimer>
      )} */}

      {isPaused && (
        <GameOverlay>
        <GameOverContent>
          <GameOverTitle>게임 일시정지</GameOverTitle>
          {/* 게임 오버 창 점수 표시 */}
          <FinalScore>
            게임이 일시정지 되었습니다 <br/>
            버튼을 눌러 게임을 계속하세요
          </FinalScore>
        </GameOverContent>
        </GameOverlay>
      )}

      {/* {showCountdown && (
        <GameOverlay>
        <GameOverContent>
          <GameOverTitle>{countdown}</GameOverTitle>
          <FinalScore>
            점프하여 장애물을 피하세요!<br/>
            스페이스바 화면 터치 <br/>
            (공중에서 한 번 더 점프 가능)
          </FinalScore>
        </GameOverContent>
        </GameOverlay>
      )} */}

        {/* YouTube 영상 */}
        {showVideo && videoUrl && (
         <VideoOverlay isMini={isVideoMini}>
           <VideoWrapper isMini={isVideoMini}>
           {!isVideoMini && (
             <VideoInstructions>
               원하는 멤버 선택 후 재생버튼을 누르세요.
               <br/>
               영상 재생 5초 후 파씨런 게임이 시작됩니다.
             </VideoInstructions>
             )}

               {/* 캐릭터 선택 버튼들 */}
               {!isVideoMini && (
               <CharacterSelector>
                 {characterImages.map((image, index) => (
                   <CharacterButton
                     key={index}
                     className={selectedCharacter === index ? 'selected' : ''}
                     onClick={() => handleCharacterSelect(index)}
                   >
                     <CharacterImage 
                       src={image} 
                       alt={`캐릭터 ${index + 1}`}
                       onError={(e) => {
                         // 이미지 로드 실패 시 기본 원형 배경으로 대체
                         e.target.style.display = 'none';
                         e.target.parentElement.style.backgroundColor = `hsl(${index * 72}, 70%, 60%)`;
                       }}
                     />
                   </CharacterButton>
                 ))}
               </CharacterSelector>
             )}
             <YoutubeIframe_L
               ref={videoRef}
               videoUrl={videoUrl}
               onVideoStart={handleVideoStart}
               onVideoMini={handleVideoMini}
               onReady={handleVideoReady}
               isMini={isVideoMini}
             />
             
           
           </VideoWrapper>
         </VideoOverlay>
         )}
             {/* 게임 캔버스 */}
       <GameCanvas 
         ref={canvasRef} 
         style={{ opacity: isVideoMini ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }} 
       />
      {isVideoMini && !isPaused && (
        <Instructions>
          스페이스바, 화살표 키 또는 화면 터치로 <strong style={{fontWeight: 'bold', fontSize: '1.2em'}}> 영파씨</strong>를 점프시키세요! <br/>(공중에서 한 번 더 점프 가능)
        </Instructions>
      )}
    </GameContainer>
  );
};

export default DinoGame; 